import { Link } from "react-router-dom";

export default function Footer() {
  const quickLinks = [
    { to: "/", label: "网站首页" },
    { to: "/category/all", label: "漫画大全" },
    { to: "/category/romance", label: "恋爱韩漫" },
    { to: "/category/fantasy", label: "奇幻韩漫" },
    { to: "/about", label: "关于我们" },
  ];

  const hotTags = ["秘密花园", "蓝色大海的传说", "剑与魔法", "黑月之夜", "第七层", "城市猎人"];

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-bold text-background-50 mb-4">
              韩漫漫画网
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫漫画网作为韩漫画免费网站，提供漫画大全和韩漫完整在线观看，内容覆盖广更新快，是您探索韩漫世界的入口。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              热门韩漫
            </h4>
            <ul className="space-y-2">
              {hotTags.map((tag) => (
                <li key={tag}>
                  <Link
                    to="/category/all"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {tag}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <p className="text-sm text-background-400 mb-2">
              <i className="ri-mail-line mr-2"></i>
              contact@hanmancomic.com
            </p>
            <p className="text-sm text-background-400 mb-2">
              <i className="ri-customer-service-2-line mr-2"></i>
              客服QQ：1234567890
            </p>
            <p className="text-sm text-background-400">
              <i className="ri-time-line mr-2"></i>
              服务时间：09:00 - 21:00
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-8 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 韩漫漫画网 版权所有 | 本站所有内容仅供学习交流，请勿用于商业用途
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/about"
              className="text-xs text-background-500 hover:text-primary-400 transition-colors"
              rel="nofollow"
            >
              关于我们
            </Link>
            <Link
              to="/about"
              className="text-xs text-background-500 hover:text-primary-400 transition-colors"
              rel="nofollow"
            >
              免责声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}